import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Sets default date
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limits the date selection to today
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Product',
                            id: 'Product',
                            label: _('Producto'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            height: screen.width > 500 && screen.height > 500 ? 0 : 100,
                            value: 1, // Default selected value
                            options: [
                                { id: 0, value: _('Detallado') },
                                { id: 1, value: _('Totales') },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form fields
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Removes Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Removes Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                        $$('b5').collapse(); // Collapses the accordion section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the second form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Gets values from the second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Removes Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Removes Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                        $$('filterPopup').hide(); // Hides the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Closes the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Displays accordion section based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hides Date field if typeDate is not 2
                $$('Datepicker').show(); // Shows Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Shows Date field if typeDate is 2
                    $$('Datepicker').hide(); // Hides Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Sets date modal configuration
        });
        webix.ready(function () {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Sets content type for AJAX request
                })
                .post(devConfig.geturlApi() + 'Select/GetProductsComissions', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Displays error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parses response text
                        $$('Product').define('options', resp.Data); // Defines options for Product select
                        $$('Product').refresh(); // Refreshes the Product select
                    },
                });
        });
    }
}

// FILE DOCUMENTED
